import { useCallback, useEffect, useState } from 'react';
import { ShieldAlert, CheckCircle2, XCircle } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { ownerApi, apiError } from './ownerApi';

// Kilitli kurulumda Platform Sahibi'nin gördüğü tek ekran: eksik maddeler (değerler gösterilmez) ve doğrulama adımları
export const SetupPanel = ({ onUnlocked }) => {
  const [s, setS] = useState(null);
  const [tests, setTests] = useState(null);
  const [busy, setBusy] = useState(false);
  const apply = useCallback((d) => { setS(d); if (!d.locked) onUnlocked(); }, [onUnlocked]);
  useEffect(() => { ownerApi.get('/platform-owner/setup').then((r) => apply(r.data)).catch((e) => toast.error(apiError(e))); }, [apply]);
  const run = (path) => {
    setBusy(true);
    ownerApi.post(path).then((r) => { if (r.data.results) setTests(r.data.results); apply(r.data); })
      .catch((e) => toast.error(apiError(e))).finally(() => setBusy(false));
  };
  if (!s) return <p className="p-12 text-center text-slate-500">Yükleniyor...</p>;
  return (
    <main className="mx-auto max-w-2xl px-6 py-10">
      <section className="space-y-4 rounded-2xl border border-slate-200 bg-white p-6" data-testid="owner-setup-panel">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-50 text-orange-500"><ShieldAlert className="h-5 w-5" /></span>
          <div><h2 className="text-lg font-semibold text-slate-900">Kurulum Kilidi</h2><p className="text-xs text-slate-500">Mod: {s.mode === 'musteri' ? 'Müşteri' : 'Ana proje'}{s.env ? ` · ${s.env}` : ''}</p></div>
        </div>
        <ul className="space-y-1.5 text-sm" data-testid="owner-setup-issues">
          {s.issues.map((i) => <li key={i} className="flex gap-2 text-slate-700"><XCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-500" />{i}</li>)}
        </ul>
        <p className="text-xs text-slate-400">Eksik değerleri Emergent Secrets bölümünden girin; ardından yeniden kontrol edin. Gizli değerler burada gösterilmez.</p>
        {tests && (
          <ul className="space-y-1 border-t border-slate-100 pt-3 text-sm" data-testid="owner-setup-gcs-results">
            {tests.map((t) => <li key={t.test} className="flex gap-2">{t.ok ? <CheckCircle2 className="h-4 w-4 text-emerald-500" /> : <XCircle className="h-4 w-4 text-red-500" />}{t.test} <span className="ml-auto text-slate-400">{t.sonuc}</span></li>)}
          </ul>
        )}
        <div className="flex gap-2">
          <Button variant="outline" disabled={busy} onClick={() => run('/platform-owner/setup/recheck')} data-testid="owner-setup-recheck">Yeniden kontrol et</Button>
          <Button disabled={busy} onClick={() => run('/platform-owner/setup/verify-gcs')} data-testid="owner-setup-verify-gcs">Google Cloud izolasyonunu doğrula</Button>
        </div>
      </section>
    </main>
  );
};
